export enum Ethnicity {    
    AmericanNative = 5,
    Asian = 10,
    AfricanAmerican = 15,
    Hispanic = 20,
    MultiRacial = 25,
    PacificIslander = 30,
    Caucasion = 35,
    Other = 40
}